import { Plan, usePlansAdminService } from 'nekst-api';
import { AfterSubmitFunc, FormBlock, FormTemplate, SubmitButton, TextInput } from 'ui-builder';
import {
  ProjectTypeDropdown,
} from 'features/tasks-forms';
import React from 'react';
import useSettingsNavigator from '../../../settingsNavigator';
import { useStateContext } from '../StateContext';

interface FormProps {
  afterSubmitFunc?: AfterSubmitFunc,
  setupAreaId: number,
  setupAreaVersion: string,
}

export function CreatePlanForm(props: FormProps) {
  const plansService = usePlansAdminService();

  const settingsNavigator = useSettingsNavigator();

  const stateContext = useStateContext();

  return (
    <FormTemplate<Plan>
      submitFormFunc={async (data) => plansService.createPlan(props.setupAreaId, props.setupAreaVersion, data)}
      afterSubmitFunc={async (data) => {
        props.afterSubmitFunc?.(data);

        settingsNavigator.openAdminMarketPlanPage(stateContext.id, props.setupAreaId, props.setupAreaVersion, data.id);
      }}
      validationSchema={plansService.getCreateValidationSchema()}
      title="Create new workflow"
      buttons={
        <SubmitButton text="Save" key="save" />
      }
    >
      <FormBlock>
        <TextInput source="name" label="Please Enter a Name for This Workflow" />
        <ProjectTypeDropdown source="projectType" label="Transaction Type" />
      </FormBlock>
    </FormTemplate>
  );
}
